module.exports = __webpack_public_path__ + "static/media/autocert.51cf7864.png";